import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { message, Row, Col, Form, Input } from 'antd';
import { ReactComponent as Link } from 'assets/images/Enlaces/white_link.svg';
import { BotonGeneracionEnlaces } from 'components/GeneracionEnlaces/BotonGeneracionEnlaces';
import PropTypes from 'prop-types';
import Modal from '../Modal/Modal';
import Button from '../Button/Button';
import './BotonGeneracionEnlaces.scss';

export const DescripcionEnlacesModal = (props) => {
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [form] = Form.useForm();
  const datosUser = useSelector((state) => state?.validarUsuario?.data);
  const { TextArea } = Input;
  const { tipoMonitoreo, tipoActa, seleccion, visible, disabledButton, onUpdateSeleccion } = props;

  useEffect(() => {
    setIsVisibleModal(visible);
  }, [visible]);

  const handleClose = () => {
    const { onClearSeleccion } = props;
    onClearSeleccion?.();
    setIsVisibleModal(false);
    form.resetFields();
  };

  const getMonitoreosSeleccionados = () => {
    const monitoreos = [];
    let validacion = false;
    Object.entries(seleccion.current).forEach(([key, value]) => {
      if (typeof key === 'string' && !key.includes('D-') && value) {
        validacion = true;
        monitoreos.push(key);
      }
    });
    if (!validacion) {
      return null;
    }
    return monitoreos;
  };

  const handleOpenModal = () => {
    onUpdateSeleccion();
    const listaIds = getMonitoreosSeleccionados();
    if (listaIds !== null) {
      setIsVisibleModal(true);
    } else {
      message.error('Debes seleccionar al menos un monitoreo.');
    }
  };

  const handleFormSubmit = async () => {
    const values = await form.validateFields(['descripcionEnlace']);
    if (values.descripcionEnlace) {
      form.submit();
      setIsVisibleModal(false);
      form.resetFields();
    }
  };

  return (
    <>
      <div className="download-type-container">
        {datosUser.rol.includes('ADMIN') || datosUser.rol.includes('VALIDADOR') ? (
          <Button
            text="Generar enlace"
            type="primary"
            size="large"
            onClick={handleOpenModal}
            icon={<Link />}
            style={{ display: 'flex', alignItems: 'center' }}
            disabled={disabledButton}
          />
        ) : (
          <div>&nbsp;</div>
        )}
      </div>
      <div>
        <Modal
          title="Generar enlace"
          visible={isVisibleModal}
          width="45em"
          onCancel={handleClose}
          footer={null}
          cancelButtonProps={{ style: { display: 'none' } }}>
          <div>
            <div style={{ padding: '25px' }}>
              <Form form={form} onFinish={handleFormSubmit}>
                <Col>
                  <span style={{ color: 'red' }}>&#42;</span>
                  <span style={{ fontWeight: '500', marginTop: '-15px' }}>
                    Descripción del enlace:
                  </span>
                </Col>
                <Col span={24} labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                  <Form.Item
                    name="descripcionEnlace"
                    rules={[{ required: true, message: 'El campo es requerido' }]}>
                    <TextArea placeholder="Escribe" rows={4} showCount maxLength={1200} />
                  </Form.Item>
                </Col>
                <Row style={{ width: '100%' }} className="margenbooton">
                  <Col span={24} className="col-header-table-col1" />
                  <Col span={24} className="margenbooton">
                    <Form.Item shouldUpdate>
                      {() => (
                        <BotonGeneracionEnlaces
                          seleccion={seleccion}
                          tipoMonitoreo={tipoMonitoreo}
                          tipoActa={tipoActa}
                          cerrarDescripcion={handleClose}
                          descripcion={form.getFieldValue('descripcionEnlace')}
                        />
                      )}
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
};

DescripcionEnlacesModal.propTypes = {
  seleccion: PropTypes.shape({ current: PropTypes.shape({ forEach: PropTypes.func }) }).isRequired,
  tipoMonitoreo: PropTypes.number.isRequired,
  tipoActa: PropTypes.number.isRequired,
  onClearSeleccion: PropTypes.func,
  visible: PropTypes.bool,
  disabledButton: PropTypes.bool.isRequired,
  onUpdateSeleccion: PropTypes.func.isRequired
};

DescripcionEnlacesModal.defaultProps = {
  onClearSeleccion: () => {
    // handleClose function here
  },
  visible: false
};

export default DescripcionEnlacesModal;
